import React, { lazy, Suspense, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { trace } from "firebase/performance";
import { perf } from "./services/firebase";
import { AuthProvider } from "./context/AuthContext";

import Header from "./components/landingPage/Header";
import Footer from "./components/landingPage/Footer";
import LoadingSpinner from "./components/dashboard/abo/LoadingSpinner";

// Lazy‑Imports wie gehabt …
const LandingPage    = lazy(() => import(/* webpackChunkName: "LandingPage" */ "./pages/LandingPage"));
const AuthPage       = lazy(() => import(/* webpackChunkName: "AuthPage"      */ "./pages/AuthPage"));
const Dashboard      = lazy(() => import(/* webpackChunkName: "Dashboard"     */ "./pages/Dashboard"));
const StoryCollection= lazy(() => import(/* webpackChunkName: "StoryCollection"*/ "./pages/StoryCollection"));
const Vision         = lazy(() => import(/* webpackChunkName: "Vision"        */ "./components/landingPage/header/MundwerteVision"));
const Reader         = lazy(() => import(/* webpackChunkName: "Reader"        */ "./components/storyCollection/Reader"));
const Favorites      = lazy(() => import(/* webpackChunkName: "Favorites"     */ "./components/storyCollection/Favorites"));
const Remember       = lazy(() => import(/* webpackChunkName: "Remember"      */ "./components/storyCollection/Remember"));
const LikedStories   = lazy(() => import(/* webpackChunkName: "LikedStories"  */ "./components/storyCollection/LikedStories"));
const StoryRanking   = lazy(() => import(/* webpackChunkName: "StoryRanking"  */ "./components/storyCollection/StoryRanking"));
const ContentManager = lazy(() => import(/* webpackChunkName: "ContentManager"*/ "./components/dashboard/ContentManager"));
const AccountSettings= lazy(() => import(/* webpackChunkName: "AccountSettings"*/ "./components/dashboard/AccountSettings"));
const Abo            = lazy(() => import(/* webpackChunkName: "Abo"           */ "./components/dashboard/Abo"));
const News           = lazy(() => import(/* webpackChunkName: "News"          */ "./components/dashboard/News"));
const Contact        = lazy(() => import(/* webpackChunkName: "Contact"       */ "./components/dashboard/Contact"));
const AccountDelete  = lazy(() => import(/* webpackChunkName: "AccountDelete" */ "./components/dashboard/AccountDelete"));
const Roadmap        = lazy(() => import(/* webpackChunkName: "Roadmap"       */ "./components/dashboard/news/Roadmap"));
const Voting         = lazy(() => import(/* webpackChunkName: "Voting"        */ "./components/dashboard/news/Voting"));
const PaymentSuccess = lazy(() => import(/* webpackChunkName: "PaymentSuccess"*/ "./components/dashboard/account/paymentProcess/PaymentSuccess"));
const PaymentFailure = lazy(() => import(/* webpackChunkName: "PaymentFailure"*/ "./components/dashboard/account/paymentProcess/PaymentFailure"));
const Impressum      = lazy(() => import(/* webpackChunkName: "Impressum"     */ "./components/landingPage/footer/Impressum"));
const Agb            = lazy(() => import(/* webpackChunkName: "Agb"           */ "./components/landingPage/footer/Agb"));
const PrivacyPolicy  = lazy(() => import(/* webpackChunkName: "PrivacyPolicy" */ "./components/landingPage/footer/PrivacyPolicy"));

function App() {
  useEffect(() => {
    const t = trace(perf, "app_loaded");
    t.start();
    t.stop();
  }, []);

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Header />
          <main className="App-body">
            <Suspense fallback={<LoadingSpinner />}>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/login" element={<AuthPage />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/story-collection" element={<StoryCollection />} />
                <Route path="/vision" element={<Vision />} />
                <Route path="/reader" element={<Reader />} />
                <Route path="/content-manager" element={<ContentManager />} />
                <Route path="/favorites" element={<Favorites />} />
                <Route path="/remember"  element={<Remember />} />
                <Route path="/liked"     element={<LikedStories />} />
                <Route path="/story-ranking" element={<StoryRanking />} />
                <Route path="/account-settings" element={<AccountSettings />} />
                <Route path="/abo"          element={<Abo />} />
                <Route path="/news"         element={<News />} />
                <Route path="/contact"      element={<Contact />} />
                <Route path="/account-delete" element={<AccountDelete />} />
                <Route path="/roadmap"      element={<Roadmap />} />
                <Route path="/voting"       element={<Voting />} />
                <Route path="/payment-success" element={<PaymentSuccess />} />
                <Route path="/payment-failure" element={<PaymentFailure />} />
                <Route path="/impressum"     element={<Impressum />} />
                <Route path="/agb"           element={<Agb />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
